// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2235":"87ce60ffcb8df887","7355":"2546ba49968471c9"}[chunkId] + ".css";
};